import * as Yup from "yup";

const validationSchema = Yup.object({
    company: Yup.string().required("Company name is required"),
    name:Yup.string().required("Name is required"),
    phone:Yup.string().required("Phone number is required").matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
    email:Yup.string().email("Invalid email format").required("Email is required"),
    role: Yup.string()
    .required("Please select a user type")
})

  export default validationSchema;